<script lang="ts">
    import Link from "@components/material/Link.svelte"
    export let href : string

</script>
<a class="underline link" {href}>
<slot />
</a>